import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { LoginService } from 'src/app/auth/login/login.service';
import { LoggerService } from 'src/app/logger.service';
import { GenericpopupComponent } from 'src/app/v2/components/genericpopup/genericpopup.component';
import { QuestionpopupComponent } from 'src/app/v2/components/questionpopup/questionpopup.component';
import * as firebase from "firebase/app";
import 'firebase/analytics';
import { Router } from '@angular/router';
import { TranslatorService } from 'src/app/translator.service';

class Port {
  public id: number;
  public name: string;
}

export class QuestionData {
  questionType: string;
  question: string;
  loadedAnswersForActiveQuestion: any = [];
  points: string;
  rightAnswer: number;
  answers: any = [];
  questionMaterie: number;
}


@Component({
  selector: 'app-customexam',
  templateUrl: './customexam.page.html',
  styleUrls: ['./customexam.page.scss'],
})
export class CustomexamPage implements OnInit {

  constructor(private router: Router, private modalCtrl: ModalController, private loginService: LoginService, private loggerService: LoggerService, public translator: TranslatorService) { }
  public questions: any = [];
  public activeUser;
  public examLabel = "";
  public numeProfesor = "";
  public dataClass: Port[];
  public classVal: Port;
  portelev: Port;
  port2elev: Port;
  port3elev: Port;

  public datalocalitati: Port[] = [];
  public dataunitati: Port[] = [];
  public datajudete: Port[] = [];

  private selectedJudet;
  private selectedLocalitate;
  private selectedUnitate;
  unitVals = [];


  async ngOnInit() {
    this.activeUser = this.loginService.activeUser;
    this.dataClass = [];

    for(let i=0; i < this.loggerService.dataClass.length; i++)
    {
      this.dataClass.push(this.loggerService.dataClass[i]);
      this.dataClass[i].name = this.translator.lang[this.loggerService.dataClass[i].name];
    }

    if (this.activeUser.uid == "testseb2") {
      const snapshot = await firebase.database().ref('/v2/carto/judete').once('value');
      let judeteSize = snapshot.numChildren();
      for (let i = 0; i < judeteSize; i++) {
        this.datajudete.push({ id: snapshot.val()[i].id, name: snapshot.val()[i].name })
      }
    }
  }

  classChanged(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    if (this.classVal) {

    }
  }


  async judetChanged(event: {
    component: IonicSelectableComponent,
    value: any
  } = null, forceID = null) {
    if ((event != null && event.value != null) || forceID != null) {
      this.selectedJudet = event != null ? event.value.id : forceID;
      const snapshot = await firebase.database().ref('/v2/carto/localitati/' + this.selectedJudet).once('value');
      let localitatiSize = snapshot.numChildren();
      this.datalocalitati = [];
      for (let i = 0; i < localitatiSize; i++) {
        this.datalocalitati.push({ id: snapshot.val()[i].id, name: snapshot.val()[i].name })
      }
      if (this.unitVals.length === 3) {
        this.port2elev = this.datalocalitati[+this.unitVals[1]];
        this.localitateChanged(null, this.unitVals[1]);
      }
    }
    else {
      this.datalocalitati = [];
    }
    this.dataunitati = [];
  }
  async localitateChanged(event: {
    component: IonicSelectableComponent,
    value: any
  } = null, forceID = null) {
    if ((event != null && event.value != null) || forceID != null) {
      this.selectedLocalitate = event != null ? event.value.id : forceID;
      const snapshot = await firebase.database().ref('/v2/carto/unitati/' + this.selectedJudet + "/" + this.selectedLocalitate).once('value');
      let unitatiSize = snapshot.numChildren();
      this.dataunitati = [];
      for (let i = 0; i < unitatiSize; i++) {
        this.dataunitati.push({ id: snapshot.val()[i].id, name: snapshot.val()[i].name })
      }
      if (this.unitVals.length === 3) {
        this.port3elev = this.dataunitati[+this.unitVals[2]];
        this.unitatiChanged(null, this.unitVals[2]);
      }
    }
    else {
      this.dataunitati = [];
    }
  }
  unitatiChanged(event: {
    component: IonicSelectableComponent,
    value: any
  } = null, forceID = null) {
    this.selectedUnitate = (event != null && event.value != null) ? event.value.id : forceID;
  }


  public onQuestionClicked(idx: number, ev: any) {
    if (ev === "remove") {
      this.questions.splice(idx, 1);
    }
    else if (ev === "update") {
      this.openQuestionPopup(this.questions[idx], "update")
    }
  }

  public onNewQuestionClicked() {
    this.openQuestionPopup(null);
  }
  private openQuestionPopup(questionData: QuestionData = null, type: string = "") {
    if (questionData === null) {
      questionData = new QuestionData();
    }
    this.modalCtrl.create({ component: QuestionpopupComponent, cssClass: "modal-fullscreen", componentProps: { questionData: questionData }, backdropDismiss: false }).then(modalEl => {
      modalEl.present();
      modalEl.onDidDismiss().then(result => {
        if (result.data.action === 'save') {
          if (type === 'update') {

          }
          else {
            this.questions.push(result.data.questionData);
          }
        }
      })
    })
  }

  public async onSaveContest() {

    let total = 0;
    for (let i = 0; i < this.questions.length; i++) {
      total += +this.questions[i].points;
    }

    if (this.classVal === undefined) {
      alert(this.translator.lang['customexamlevel']);
      return;
    }
    if (this.examLabel.length === 0) {
      alert(this.translator.lang['customexamtitle']);
      return;
    }

    if (total != 90) {
      alert(this.translator.lang['customexamtitle']);
      alert("Pentru a salva acest test este necesar să aveți un total de 90 de puncte! 10 puncte vor fi acordate din oficiu fiecărui participant")
    }
    else {
      let bodyMessage = this.translator.lang['customexampublic'];
      let buttons = [{ label: this.translator.lang['customexampublicyes'], action: 0 }, { label: this.translator.lang['customexamprivateyes'], action: 1 }, { label: this.translator.lang['customexamcancel'], action: 2 }];
      this.modalCtrl.create({ component: GenericpopupComponent, componentProps: { title: this.translator.lang['popupcongratulations'], body: bodyMessage, buttons: buttons }, backdropDismiss: false }).then(modalEl => {
        modalEl.present();
        modalEl.onDidDismiss().then(async result => {
          if (+result.data.action === 2) {

          }
          else if (+result.data.action === 0) {

            let teacherPath = "v2/customtests/"
            await this.loginService.grabdata("v2/customtests/" + this.loginService.languagePath + "counter").then((data: any) => {
              if (data.data != "fail") {
                let counter = data.data;
                let vals = {};
                counter++;
                vals['counter'] = counter;
                this.loginService.updatedata("v2/customtests/" + this.loginService.languagePath, vals);

                counter = data.data;
                vals = {};
                if (this.activeUser.uid == "testseb2") {
                  vals['name'] = this.numeProfesor;
                  vals['judet'] = this.portelev.name;
                  vals['localitate'] = this.port2elev.name;
                  vals['unitate'] = this.port3elev.name;
                  vals['status'] = true;
                }
                else {
                  vals['name'] = this.activeUser.name;
                  vals['judet'] = this.activeUser.judetLabel;
                  vals['localitate'] = this.activeUser.cityLabel;
                  vals['unitate'] = this.activeUser.unitateLabel;
                  vals['status'] = false;

                  let message = "Am inregistrat testul cu ID-ul " + counter + " . Necesita activare pentru " + this.loginService.activeUser.name;
                  this.loginService.sendMailToOffice(this.loginService.activeUser.name, this.loginService.activeUser.email, message);

                }
                vals['clasa'] = this.classVal.id;
                vals['uid'] = this.activeUser.uid;
                vals['title'] = this.examLabel;

                this.loginService.updatedata("v2/customtests/" + this.loginService.languagePath + "struct/" + counter, vals);


                vals = {};

                for (let i = 0; i < this.questions.length; i++) {
                  let qPath = "v2/customtests/" + this.loginService.languagePath + "tests/" + counter + "/questions/q" + (i + 1);
                  let internalVals = {};
                  internalVals['id'] = (i + 1);
                  internalVals['label'] = this.questions[i].question;
                  internalVals['points'] = this.questions[i].points;
                  internalVals['questionType'] = this.questions[i].questionType;
                  internalVals['questionMaterie'] = this.questions[i].questionMaterie;
                  let rightAnswer = "";
                  let answers = "";
                  for (let k = 0; k < this.questions[i].answers.length; k++) {
                    if (+this.questions[i].questionType === 1) {
                      if (this.questions[i].answers[k].val === "true") {
                        rightAnswer = "" + k;
                      }
                    } else if (+this.questions[i].questionType === 2) {
                      rightAnswer += this.questions[i].answers[k].val;
                      if (k != this.questions[i].answers.length - 1) {
                        rightAnswer += ","
                      }
                    }
                    answers += this.questions[i].answers[k].label;
                    if (k != this.questions[i].answers.length - 1) {
                      answers += "|"
                    }
                  }
                  internalVals['rightAnswer'] = rightAnswer;
                  internalVals['answers'] = answers;
                  this.loginService.updatedata(qPath, internalVals);

                  let bodyMessage = this.translator.lang['customexamlink'];
                  let buttons = [{ label: this.translator.lang['customexamback'], action: 0 }];
                  let title = "https://testescolare/auth/tabs/demo?customToken=" + counter;
                  this.modalCtrl.create({
                    component: GenericpopupComponent,
                    componentProps: { title: title, body: bodyMessage, buttons: buttons },
                    backdropDismiss: false,
                    cssClass: "modal-quarter"
                  }).then(modalEl => {
                    modalEl.present();
                    modalEl.onDidDismiss().then(result => {
                      this.router.navigateByUrl("/home/tabs/shop");
                    })
                  })
                }
              }
              else {
                alert(this.translator.lang['customexamerr']);
              }
            });
          }
          else {
            let unit = this.activeUser.userUnitID.split("_");
            let path = 'v2/judete/' + unit[0] + "/localitati/" + unit[1] + "/unitati/" + unit[2] + "/teachers/" + this.activeUser.uid + "/tests/";
            await this.loginService.grabdata(path + "data").then((data: any) => {
              if (data.data != "fail") {
                //console.log(data.data);
                let counter = -1;
                let titles = "";
                let clasa = "";
                //console.log(data.data);
                if (data.data != undefined) {
                  counter = +data.data.counter;
                  titles = data.data.titles + this.examLabel + "|";
                  clasa = data.data.clasa + this.classVal.id + "|";
                }
                else {
                  titles = this.examLabel + "|"
                  clasa = this.classVal.id + "|";
                }
                counter++;
                let vals = {};
                vals['counter'] = counter;
                vals['titles'] = titles;
                vals['clasa'] = clasa;

                this.loginService.updatedata(path + "/data/", vals);
                let titleVals = {};
                titleVals['title'] = this.examLabel;
                this.loginService.updatedata(path + counter + "/", titleVals);
                for (let i = 0; i < this.questions.length; i++) {
                  let qPath = path + "/" + counter + "/questions/q" + (i + 1);
                  let internalVals = {};
                  internalVals['id'] = (i + 1);
                  internalVals['label'] = this.questions[i].question;
                  internalVals['points'] = this.questions[i].points;
                  internalVals['questionType'] = this.questions[i].questionType;
                  internalVals['questionMaterie'] = this.questions[i].questionMaterie;
                  let rightAnswer = "";
                  let answers = "";
                  for (let k = 0; k < this.questions[i].answers.length; k++) {
                    if (+this.questions[i].questionType === 1) {
                      if (this.questions[i].answers[k].val === "true") {
                        rightAnswer = "" + k;
                      }
                    } else if (+this.questions[i].questionType === 2) {
                      rightAnswer += this.questions[i].answers[k].val;
                      if (k != this.questions[i].answers.length - 1) {
                        rightAnswer += ","
                      }
                    }
                    answers += this.questions[i].answers[k].label;
                    if (k != this.questions[i].answers.length - 1) {
                      answers += "|"
                    }
                  }
                  internalVals['rightAnswer'] = rightAnswer;
                  internalVals['answers'] = answers;
                  this.loginService.updatedata(qPath, internalVals);
                }

              }
              else {
                alert(this.translator.lang['customexamerr']);
              }
            });
          }
        })
      })
    }
  }

}
